import { Button } from './Button.js'
import { StateArt } from './StateArt.js'

export type ErrorStateProps = {
  /** Turkish, from content/copy. Never a stack trace, never English. */
  text: string
  retryLabel: string
  onRetry: () => void
  /** The art id for the picture. `misc/error` unless a screen has a better one. */
  art?: string
  /** Dev only detail, shown under the copy so a worker can see what broke. */
  detail?: string | null
}

/** CONVENTIONS §3: every async surface has an error state and it always offers a retry. */
export function ErrorState({
  text,
  retryLabel,
  onRetry,
  art = 'misc/error',
  detail,
}: ErrorStateProps) {
  return (
    <div className="state" role="alert">
      <StateArt id={art} />
      <p className="state__text">{text}</p>
      {import.meta.env.DEV && detail ? (
        <p className="state__text" style={{ fontSize: 'var(--text-xs)' }}>
          {detail}
        </p>
      ) : null}
      <Button onClick={onRetry}>{retryLabel}</Button>
    </div>
  )
}
